import {
  AutoComplete,
  Button,
  Col,
  Divider,
  Form,
  Popconfirm,
  Row,
  Skeleton,
  Switch,
  Table,
  Tooltip,
} from 'antd';
import React, { ReactElement, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Panel from '../../../../shared/components/card/Panel';
import {
  APPLICATION_ID,
  authFeatureConstants,
  FETCH_PACKAGE,
  GUTTOR_SPACE,
  INVENTORY_MESSAGE_CONSTANTS,
  INVENTROY_CONSTANTS,
  PACKAGE_TYPE,
  PAGE_QUERY_PARAM,
  TOOLTIP_TEXT,
} from '../../../../shared/constants/commonConstants';
import {
  Consultation,
  PackageDetailBase,
  Test,
} from '../../../../shared/models/healthcheck.model';
import {
  FetchPackageRequest,
  FetchPackageResponse,
} from '../../../../shared/models/packageDetail.model';
import SendRequest from '../../../../shared/services/sendRequest.service';
import { base64UrlDecode, base64UrlEncode, canActivate, error, formatPrice, success } from '../../../../utils/utility';
import { extractSecondLevelBaseUrl, GetFirstElement } from './../../../../utils/utility';
import { INVENTORY_SAVE_HEALTHCHECK } from '../../../../shared/constants/urlEndPoints';
import PageHeader from '../../../../shared/components/pageHeader/PageHeader';
import { ReactComponent as EditIcon } from '../../../../assets/images/svg/i_edit.svg';

const HealthCheckPackageDetail = ({
  match: {
    path,
    params: { id: packageId },
  },
}: any): ReactElement => {
  const pageNumber: any = new URLSearchParams(useLocation().search).get('page');
  const [packageDetail, setPackageDetailHandler] = useState(null as any);
  const [consulationData, setConsultationData] = useState(null as any);
  const [consulationSelect, setConsultationSelect] = useState(null as any);
  const [historyConsulationData, setHistoryConsulationData] = useState(
    null as any,
  );
  const [testData, setTestData] = useState(null as any);
  const [testDataFilter, setTestDataFilter] = useState(null as any);
  const [investigationGroup, setinvestigationGroup] = useState(null as any);
  const [investigationList, setInvestigationList] = useState(null as any);
  const [isChecked, setIsChecked] = useState(true);
  const history = useHistory();
  const id = base64UrlDecode(packageId);
  const isAuthrized = canActivate(authFeatureConstants.EDIT_HEALTH_CHECK_PACKAGES);
  const fetchPackageDetail = async (payload: any): Promise<any> => {
    const url = process.env.REACT_APP_INVENTORY_API_BASE_URL + FETCH_PACKAGE;
    const result: any = await SendRequest.instance.post<
      FetchPackageRequest,
      FetchPackageResponse
    >(url, payload);
    if (result && result.isSuccess && result.packages) {
      setPackageDetailHandler(GetFirstElement(result.packages));
      setIsChecked(GetFirstElement(result.packages).isActive);
      if (GetFirstElement(result.packages) && GetFirstElement(result.packages)?.consultations) {
        const data = [] as any;
        data.push({
          key: 0,
          subject: 'All',
          value: 'All',
        });
        GetFirstElement(result.packages)?.consultations?.filter((i: any): any => i.isActive).map((item: any): any =>
          data.push({
            key: item.id,
            subject: item.name,
            value: item.name,
          }),
        );
        setConsultationData(data);
        setConsultationSelect(data);
        setHistoryConsulationData(data);
      }
      if (GetFirstElement(result.packages) && GetFirstElement(result.packages)?.investigations) {
        const data = [] as any;
        data.push({
          key: 0,
          groupname: 'All',
          testname: 'All',
          value: 'All',
        });
        GetFirstElement(result.packages)?.investigations?.filter((i: any): any => i.isActive).map((item: any): any =>
          data.push({
            key: item.id,
            groupname: item.groupName,
            testname: item.name,
            value: item.name,
          }),
        );
        setTestData(data);
        setTestDataFilter(data);

        // tslint:disable-next-line: no-shadowed-variable
        const investigationGroup = [] as any;
        investigationGroup.push({
          key: 0,
          groupname: 'All',
          value: 'All',
        });
        data.map((item: any): any => {
          if (
            !investigationGroup.some(
              (x: any): any => item.groupname === x.groupname,
            )
          ) {
            investigationGroup.push({
              key: item.id,
              groupname: item.groupname,
              value: item.groupname,
            });
          }
        });
        setinvestigationGroup(investigationGroup);
      }
    } else {
      error(INVENTORY_MESSAGE_CONSTANTS.tryAgain);
    }
  };

  useEffect((): void => {
    const reqpayload: FetchPackageRequest = {
      packageById: true,
      packageType: PACKAGE_TYPE.HEALTHCHECK,
      fetchInActiveRecord: true,
      ids: [+id],
    };
    fetchPackageDetail(reqpayload);
  }, [id]);

  const testColumns = [
    {
      title: 'Group name',
      dataIndex: 'groupname',
      key: 'groupname',
    },
    {
      title: 'Test name',
      dataIndex: 'testname',
      key: 'testname',
    },
  ];
  const consultationColumns = [
    {
      title: 'Subject',
      dataIndex: 'subject',
      key: 'subject',
    },
  ];

  const onConsultationSelect = (val: any, data: any): void => {
    if (data.value !== 'All') {
      setConsultationData(
        historyConsulationData.filter(
          (item: any): any => data.value === item.value,
        ),
      );
    } else {
      setConsultationData(historyConsulationData);
    }
  };

  const onInvestigationGroupFilter = (val: any, data: any): void => {
    if (data.value !== 'All') {
      setTestDataFilter(
        testData.filter((item: any): any => data.groupname === item.groupname),
      );
      setInvestigationList(
        testData.filter((item: any): any => data.groupname === item.groupname),
      );
    } else {
      setTestDataFilter(testData);
      setInvestigationList([]);
    }
  };

  const onInvestigationListFilter = (val: any, data: any): void => {
    if (data.value !== 'All') {
      setTestDataFilter(
        testData.filter((item: any): any => data.value === item.value),
      );
    } else {
      setTestDataFilter(testData);
    }
  };

  const onFilter = (inputValue: string, option: any): boolean => {
    return option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1;
  };

  const onEditPackage = (): void => {
    history.push(extractSecondLevelBaseUrl(path) +
      INVENTROY_CONSTANTS.hcEditPackageRoute + base64UrlEncode(id) + PAGE_QUERY_PARAM + pageNumber);
  };

  const onDeletePackage = async (active: boolean): Promise<void> => {
    const testArray = [] as any;
    const consultationArray = [] as any;
    if (packageDetail?.investigations) {
      packageDetail?.investigations.map((item: any): void => {
        const investigation: Test = {
          investigationId: item.id,
          departmentId: item.groupId,
          isActive: item.isActive,
        };
        testArray.push(investigation);
      });
    }

    if (packageDetail?.consultations) {
      packageDetail?.consultations.map((item: any): void => {
        const consul: Consultation = {
          consultationId: item.id,
          isActive: item.isActive,
        };
        consultationArray.push(consul);
      });
    }
    const packageDetails: PackageDetailBase = {
      id: packageDetail?.id,
      isActive: active,
      profileId: packageDetail?.profileId,
      statusName: packageDetail?.statusName,
      package: {
        description: packageDetail?.description,
        discountedPrice: packageDetail?.discountedPrice,
        gender: packageDetail?.gender,
        maxAge: packageDetail?.maxAge,
        minAge: packageDetail?.minAge,
        name: packageDetail?.packageName,
        price: packageDetail?.price,
      },
      tests: testArray,
      consultations: consultationArray,
      specificInstructions: packageDetail?.specificInstruction,
      generalInstructions: packageDetail?.generalInstruction,
    };
    const payload = {
      applicationId: APPLICATION_ID,
      packageDetails: [packageDetails],
    };
    const url =
      process.env.REACT_APP_INVENTORY_API_BASE_URL + INVENTORY_SAVE_HEALTHCHECK;
    const response: any = await SendRequest.instance.post(url, payload);
    if (response && response.isSuccess) {
      if (isChecked) {
        success(INVENTORY_MESSAGE_CONSTANTS.isDeactivatedSuccess);
      } else {
        success(INVENTORY_MESSAGE_CONSTANTS.isActivatedSuccess);
      }
      setIsChecked(!isChecked);
    } else if (response && response.errorMessage) {
      error(response.errorMessage);
    } else {
      error(INVENTORY_MESSAGE_CONSTANTS.packageUpdateFail);
    }
    return;
  };

  const isSpecificInstruction = (): boolean => {
    return packageDetail?.specificInstructions &&
      packageDetail?.specificInstructions?.length > 0;
  };

  return (
    <div>
      <PageHeader
        colSize={18}
        pageTitle={packageDetail?.packageName}
        backUrl={extractSecondLevelBaseUrl(path) + INVENTROY_CONSTANTS.hcPackageRoute + PAGE_QUERY_PARAM + (pageNumber ? pageNumber : 1)}
        rightComponent={
          (): ReactElement =>
            <Row gutter={GUTTOR_SPACE}>
              <Col md={24} className="text-right">
                <div className="text-right">
                  {
                    isAuthrized &&
                    <Tooltip title={TOOLTIP_TEXT.edit} placement={'bottom'}>
                      <Button className="v-align-sub" type={'text'} onClick={onEditPackage} >
                        <EditIcon className="fill-primary" />
                      </Button>
                    </Tooltip>
                  }
                  <Popconfirm
                    disabled={!isAuthrized}
                    placement={'topLeft'}
                    title={!isChecked ? INVENTORY_MESSAGE_CONSTANTS.isActivatePackage : INVENTORY_MESSAGE_CONSTANTS.isDeActivatePackage}
                    onConfirm={(): any => onDeletePackage(!isChecked)}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Tooltip placement={'bottom'} title={isChecked ? TOOLTIP_TEXT.active : TOOLTIP_TEXT.inActive}>
                      <Button type={'text'}>
                        <Switch disabled={!isAuthrized} size="small" checked={isChecked} />
                      </Button>
                    </Tooltip>
                  </Popconfirm>
                </div>
              </Col>
            </Row>}
      />
      {packageDetail && (
        <div className="ant-tabs-content-holder tab-custom-container">
          <Row gutter={GUTTOR_SPACE}>
            <Col md={16}>
              <Panel title="Package Details">
                <div className="label-value mb-0">
                  {packageDetail?.packageName}
                </div>
                <p className="text-elipsis"
                  style={{ whiteSpace: 'pre-wrap' }} dangerouslySetInnerHTML={{ __html: packageDetail?.description }} />
                <Row gutter={GUTTOR_SPACE}>
                  <Col md={6}>
                    <p className="label-title">Gender</p>
                    <div className="label-value mb-0">
                      {packageDetail?.gender}
                    </div>
                  </Col>
                  <Col md={6}>
                    <p className="label-title">Age range</p>
                    <div className="label-value mb-0">
                      {packageDetail?.minAge + '-' + packageDetail?.maxAge}
                    </div>
                  </Col>
                  <Col md={6}>
                    <p className="label-title">Package price</p>
                    <div className="label-value mb-0">
                      {formatPrice(packageDetail?.price, false)}
                    </div>
                  </Col>
                  <Col md={6}>
                    <p className="label-title">Discounted price</p>
                    <div className="label-value mb-0">
                      {formatPrice(packageDetail?.discountedPrice, false)}
                    </div>
                  </Col>
                </Row>
              </Panel>
              <Panel title="Test Details"
                extra={
                  <span style={{ textAlign: 'center' }}>
                    <b>
                      {(testDataFilter?.filter((i: any): any => i.value !== 'All')?.length) + ' Tests'}
                    </b>
                  </span>
                }
              >
                <Row gutter={GUTTOR_SPACE}>
                  <Col md={8}>
                    <p className="label-title">Group name</p>
                    <Form.Item>
                      <AutoComplete
                        disabled={!isAuthrized}
                        options={investigationGroup}
                        onSelect={(val: any, option: any): any =>
                          onInvestigationGroupFilter(val, option)
                        }
                        filterOption={onFilter}
                        placeholder="Select group"
                      />
                    </Form.Item>
                    <p className="label-title">Tests</p>
                    <Form.Item className="mb-0">
                      <AutoComplete
                        disabled={!isAuthrized}
                        options={investigationList}
                        onSelect={(val: any, option: any): any =>
                          onInvestigationListFilter(val, option)
                        }
                        filterOption={onFilter}
                        placeholder="Search test"
                      />
                    </Form.Item>
                  </Col>
                  <Col md={16} style={{ marginTop: '19px' }}>
                    <Table
                      scroll={{ y: 300 }}
                      className="panel-table"
                      columns={testColumns}
                      dataSource={testDataFilter?.filter(
                        (item: any): any => item.value !== 'All',
                      )}
                      bordered={true}
                      pagination={false}
                      size="small"
                    />
                  </Col>
                </Row>
              </Panel>
              {consulationData && consulationData?.length > 1 &&
                <Panel
                  title="Consultation Details"
                  extra={
                    <span style={{ textAlign: 'center' }}>
                      <b>
                        {(consulationData.filter((i: any): any => i.value !== 'All')?.length) + ' Consultations'}
                      </b>
                    </span>
                  }
                >
                  <Row gutter={GUTTOR_SPACE}>
                    <Col md={8}>
                      <p className="label-title">Consultation</p>
                      <Form.Item>
                        <AutoComplete
                          disabled={!isAuthrized}
                          options={consulationSelect}
                          onSelect={(val: any, option: any): any =>
                            onConsultationSelect(val, option)
                          }
                          filterOption={onFilter}
                          placeholder="Search consultation"
                        />
                      </Form.Item>
                    </Col>
                    <Col md={16} style={{ marginTop: '19px' }}>
                      <Table
                        scroll={{ y: 300 }}
                        className="panel-table"
                        columns={consultationColumns}
                        dataSource={consulationData?.filter(
                          (item: any): any => item.value !== 'All',
                        )}
                        bordered={true}
                        pagination={false}
                        size="small"
                      />
                    </Col>
                  </Row>
                </Panel>
              }
            </Col>
            <Col md={8}>
              <Panel title="Instructions">
                <h5 className="h5">General</h5>
                <ol className="inclusion-list">
                  {packageDetail?.generalInstructions &&
                    packageDetail?.generalInstructions?.map(
                      (item: any, index: number): any => {
                        if (item.isImportant) {
                          return <div>
                            <a className="starBtn starBtnActive">
                              <svg fill="currentColor" viewBox="0 -10 511.98685 511" xmlns="http://www.w3.org/2000/svg"><path d="m510.652344 185.902344c-3.351563-10.367188-12.546875-17.730469-23.425782-18.710938l-147.773437-13.417968-58.433594-136.769532c-4.308593-10.023437-14.121093-16.511718-25.023437-16.511718s-20.714844 6.488281-25.023438 16.535156l-58.433594 136.746094-147.796874 13.417968c-10.859376 1.003906-20.03125 8.34375-23.402344 18.710938-3.371094 10.367187-.257813 21.738281 7.957031 28.90625l111.699219 97.960937-32.9375 145.089844c-2.410156 10.667969 1.730468 21.695313 10.582031 28.09375 4.757813 3.4375 10.324219 5.1875 15.9375 5.1875 4.839844 0 9.640625-1.304687 13.949219-3.882813l127.46875-76.183593 127.421875 76.183593c9.324219 5.609376 21.078125 5.097657 29.910156-1.304687 8.855469-6.417969 12.992187-17.449219 10.582031-28.09375l-32.9375-145.089844 111.699219-97.941406c8.214844-7.1875 11.351563-18.539063 7.980469-28.925781zm0 0" fill="#ffc107" /></svg>
                            </a>
                            <li className="fsize_sm" key={index + 1}> {item.value} </li>
                          </div>;
                        } else {
                          return <li className="fsize_sm" key={index + 1}> {item.value} </li>;
                        }
                      },
                    )}
                </ol>
                {isSpecificInstruction() && (<Divider />)}
                {isSpecificInstruction() && (<h5 className="h5">Specific</h5>)}
                <ol className="inclusion-list">
                  {isSpecificInstruction() &&
                    packageDetail?.specificInstructions?.map(
                      (item: any, index: number): any => {
                        if (item.isImportant) {
                          return <div>
                            <a className="starBtn starBtnActive">
                              <svg fill="currentColor" viewBox="0 -10 511.98685 511" xmlns="http://www.w3.org/2000/svg"><path d="m510.652344 185.902344c-3.351563-10.367188-12.546875-17.730469-23.425782-18.710938l-147.773437-13.417968-58.433594-136.769532c-4.308593-10.023437-14.121093-16.511718-25.023437-16.511718s-20.714844 6.488281-25.023438 16.535156l-58.433594 136.746094-147.796874 13.417968c-10.859376 1.003906-20.03125 8.34375-23.402344 18.710938-3.371094 10.367187-.257813 21.738281 7.957031 28.90625l111.699219 97.960937-32.9375 145.089844c-2.410156 10.667969 1.730468 21.695313 10.582031 28.09375 4.757813 3.4375 10.324219 5.1875 15.9375 5.1875 4.839844 0 9.640625-1.304687 13.949219-3.882813l127.46875-76.183593 127.421875 76.183593c9.324219 5.609376 21.078125 5.097657 29.910156-1.304687 8.855469-6.417969 12.992187-17.449219 10.582031-28.09375l-32.9375-145.089844 111.699219-97.941406c8.214844-7.1875 11.351563-18.539063 7.980469-28.925781zm0 0" fill="#ffc107" /></svg>
                            </a>
                            <li className="fsize_sm" key={index + 1}> {item.value} </li>
                          </div>;
                        } else {
                          return <li className="fsize_sm" key={index + 1}> {item.value} </li>;
                        }
                      },
                    )}
                </ol>
              </Panel>
            </Col>
          </Row>
        </div>
      )}
      {!packageDetail && (
        <div className="ant-tabs-content-holder tab-custom-container">
          <Row gutter={GUTTOR_SPACE}>
            <Col md={14}>
              <Row>
                <Skeleton active={true} />
              </Row>
              <br />
              <Row>
                <Skeleton active={true} />
              </Row>
              <br />
              <Row>
                <Skeleton active={true} />
              </Row>
            </Col>
            <Col md={2} />
            <Col md={8}><Skeleton active={true} /></Col>
          </Row>
        </div>
      )}
    </div>
  );
};
export default HealthCheckPackageDetail;
